import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { UiComponentsRoutingModule } from './ui-components-routing.module';
import { CommonComponentModule } from '../common-component/common-component.module';
import {
  NotificationsModalComponent,
  NotificationsCardItemComponent,
  MoveToComponent,
 } from '../components';
import { TimeAgoExtendsPipePipe } from '../directives/pipe/pipe.module';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { UiWrapperComponent } from './ui-wrapper/ui-wrapper.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { PipeModule } from '../directives/pipe/pipe.module';


@NgModule({
  declarations: [
    MoveToComponent,
    NotificationsModalComponent,
    NotificationsCardItemComponent,
    SidebarComponent,
    TimeAgoExtendsPipePipe,
    //TimeAgoPipe,
    TopbarComponent,
    ToolbarComponent,
    UiWrapperComponent,
  ],
  imports: [
    CommonModule,
    CommonComponentModule,
    UiComponentsRoutingModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    SharedComponentsModule,
    PipeModule
  ],
})

export class UiComponentsModule { }
